import { apiKeyNews } from './apiKey'
import CryptoJS from 'crypto-js';

export const setToken = ({ accessToken, refreshToken }, isRemember) => {
	if (isRemember === undefined) {
		isRemember = localStorage.getItem('isRemember')
	}

	if (isRemember) {
		localStorage.setItem('token', accessToken)
		if(refreshToken){
			localStorage.setItem('refreshToken', refreshToken)
		}
		localStorage.setItem('isRemember', 'true')
	} else {
		sessionStorage.setItem('token', accessToken)
		if(refreshToken){
			sessionStorage.setItem('refreshToken', refreshToken)
		}
	}
}

export const getToken = () => {
	if (localStorage.getItem('isRemember')) {
		return {
			token: localStorage.getItem('token'),
			refreshToken: localStorage.getItem('refreshToken')
		}
	} else {
		return {
			token: sessionStorage.getItem('token'),
			refreshToken: sessionStorage.getItem('refreshToken')
		}
	}
}

export const passwordEncrypt = function(data) {
   let encryptLocalStorage = CryptoJS.AES.encrypt(JSON.stringify(data), "6A45soD%9eB#",
   {
      keySize: 128 / 8,
      iv: "6A45soD%9eB#",
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
   }).toString();

   localStorage.setItem('profileDetailPW', encryptLocalStorage)
}

export const passwordDecrypt = function() {
   if(localStorage.getItem('profileDetailPW')){
     return JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(localStorage.getItem('profileDetailPW'),  "6A45soD%9eB#", 
      {
          keySize: 128 / 8,
          iv: "6A45soD%9eB#",
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        })));
   }else{
     return null
   }
}

export const userNameEncrypt = function(data) {
   let encryptLocalStorage = CryptoJS.AES.encrypt(JSON.stringify(data), "6A45soD%9eB#",
   {
      keySize: 128 / 8,
      iv: "6A45soD%9eB#",
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
   }).toString();

   localStorage.setItem('profileDetailUN', encryptLocalStorage)
}

export const userNameDecrypt = function() {
   if(localStorage.getItem('profileDetailUN')){
     return JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(localStorage.getItem('profileDetailUN'),  "6A45soD%9eB#", 
      {
          keySize: 128 / 8,
          iv: "6A45soD%9eB#",
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        })));
   }else{
     return null
   }
}



export const isLoggedIn = () => {
	if (localStorage.getItem('isRemember')) {
		return !!localStorage.getItem('token') && !!localStorage.getItem('refreshToken')
	} else {
		return !!sessionStorage.getItem('token') && !!sessionStorage.getItem('refreshToken')
	}
}

export const clearAllStorage = () => {
	localStorage.clear()
	sessionStorage.clear()
}

export const getLsId = () =>{
	return localStorage.getItem('lsid')
}

export const getIsTrial = () =>{
   return localStorage.getItem('IsTrial')
}

export const getSessionID = () =>{
	return localStorage.getItem('sessionID')
}

export const getOrganization = () => {
	return "3F3BF3AD-B4C9-4D44-A56F-AB55C4E4FB01-00"
	// return sessionStorage.getItem('organization')
}

export const profileObjectKey = () => {
	return localStorage.getItem('objectValuePF') ?  JSON.parse(localStorage.getItem('objectValuePF')) : null
	// return sessionStorage.getItem('organization')
}

export const employeeDetailObjectKey = () => {
	return localStorage.getItem('objectValueEM') ?  JSON.parse(localStorage.getItem('objectValueEM')) : null
	// return sessionStorage.getItem('organization')
}

export const UrlMeeting = () => {
	// return "https://vtrcdev.redcross.or.th"
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
      return 'https://vtrcdev.redcross.or.th'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
      return 'https://uat-vtrcapi.redcross.or.th'
   }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://localhost:8000/")){
      return 'https://uat-vtrcapi.redcross.or.th'
   }
}

export const UrlAbstainTime = () => {
	// return "https://vtrcdev.redcross.or.th"
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
      return 'https://vtrcdev.redcross.or.th'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
      return 'https://uat-vtrcapi.redcross.or.th';
   }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://localhost:8000/")){
      return 'https://uat-vtrcapi.redcross.or.th';
   }
}


export const UrleventLog = () => {
	// return "https://vtrcdev.redcross.or.th"
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
      return 'https://vtrcapi.redcross.or.th/log-event-api/api/v1/logEvent'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
      return 'https://uat-vtrcapi.redcross.or.th/log-event-api/api/v1/logEvent'
   }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://localhost:8000/")){
      return 'https://uat-vtrcapi.redcross.or.th/log-event-api/api/v1/logEvent'
   }
}


export const removeItemSession = ($sessions) => {
	sessionStorage.removeItem($sessions)
}

export const appVersion = () => {
	return '1.8.0';
}

export const versionWeb = () =>{
    if(window.location.href.includes("https://vtrc.redcross.or.th/")){
        return 'Web App version'
    }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
        return 'UAT Web App version'
	}else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
        return 'UAT Web App version'
    }
}

export const checkLinkURL = () =>{
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
       return 'https://vtrcapi.redcross.or.th/'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/'
  }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
       return 'https://uat-vtrcapi.redcross.or.th/'
   }
}

export const checkLinkUrlVtrcCustom = () =>{
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1'
  }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
       return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1'
   }
}

export const workforce = () =>{
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
       return 'https://vtrcapi.redcross.or.th/workforce-api/api/restful/'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/workforce-api/api/restful/'
  }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
       return 'https://uat-vtrcapi.redcross.or.th/workforce-api/api/restful/'
   }
}

export const urlCommon = () =>{
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1/'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1/'
  }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
       return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1/'
   }
}


export const urlBenefit = () =>{
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
       return 'https://vtrcapi.redcross.or.th/benefit-api/api/v1/'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/benefit-api/api/v1/'
  }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
       return 'https://uat-vtrcapi.redcross.or.th/benefit-api/api/v1/'
   }
}